export function getTodayDateKey() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

// ── Legacy helpers (kept for compatibility; not used by current app) ──────────
export function hasCompletedMealOnDate(completionHistory, dateKey) {
  const mealsForDate = completionHistory[dateKey];
  if (!mealsForDate) return false;
  return Object.values(mealsForDate).some(Boolean);
}

export function calculateStreak(completionHistory) {
  let streak = 0;
  const checkDate = new Date();
  while (true) {
    const year = checkDate.getFullYear();
    const month = String(checkDate.getMonth() + 1).padStart(2, "0");
    const day = String(checkDate.getDate()).padStart(2, "0");
    const dateKey = `${year}-${month}-${day}`;
    if (hasCompletedMealOnDate(completionHistory, dateKey)) {
      streak++;
      checkDate.setDate(checkDate.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}

// ── Supabase-backed helpers (use completedMeals: { "YYYY-MM-DD-mealtype": true }) ──
export function isDateCompletedFromMeals(completedMeals, dateKey) {
  return ["breakfast", "lunch", "dinner"].some(mt => completedMeals[`${dateKey}-${mt}`]);
}

export function calculateStreakFromCompletedMeals(completedMeals) {
  let streak = 0;
  const checkDate = new Date();
  while (true) {
    const year = checkDate.getFullYear();
    const month = String(checkDate.getMonth() + 1).padStart(2, "0");
    const day = String(checkDate.getDate()).padStart(2, "0");
    const dateKey = `${year}-${month}-${day}`;
    if (isDateCompletedFromMeals(completedMeals, dateKey)) {
      streak++;
      checkDate.setDate(checkDate.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}

export function getProfileCalendarDateKey(
  dayNumber,
  profileCalendarYear,
  profileCalendarMonth
) {
  if (!dayNumber) return "";

  const year = profileCalendarYear;
  const month = String(profileCalendarMonth + 1).padStart(2, "0");
  const day = String(dayNumber).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function changeProfileCalendarMonth(prevDate, direction) {
  return new Date(
    prevDate.getFullYear(),
    prevDate.getMonth() + direction,
    1
  );
}

export function getMealTimePickerState(meal, breakfastTime, lunchTime, dinnerTime) {
  const timeMap = {
    breakfast: breakfastTime,
    lunch: lunchTime,
    dinner: dinnerTime
  };

  const time = timeMap[meal];
  const parts = time.split(" ");
  const period = parts[1];
  const timeParts = parts[0].split(":");
  const hour = timeParts[0];
  const minute = timeParts[1];

  return {
    hour,
    minute,
    period,
    meal
  };
}